<ng-container *ngIf="vm$ | async as vm">
  <div
    class="report-card report-card--loading"
    [ngClass]="cardClass"
    *ngIf="vm.loading"
  >
    <button mat-flat-button disabled>
      <mat-progress-spinner
        class="report-loading-spinner"
        diameter="16"
        mode="indeterminate"
      ></mat-progress-spinner
      ><span class="report-button-label">
        <span class="report-button-label-prefix" *ngIf="buttonLabelPrefix">{{
          buttonLabelPrefix
        }}</span
        ><span class="report-button-label-base">{{ buttonLabel }}s</span>
      </span>
    </button>
  </div>

  <div
    class="report-card report-card--disabled"
    [ngClass]="cardClass"
    *ngIf="!vm.loading && vm.portfolioInsufficientCompanies"
  >
    <button id="reports-button" mat-flat-button disabled>
      <span class="report-button-label">
        <span class="report-button-label-prefix" *ngIf="buttonLabelPrefix">{{
          buttonLabelPrefix
        }}</span
        ><span class="report-button-label-base">{{ buttonLabel }}</span>
      </span>
    </button>
    <mat-icon
      class="report-info-icon"
      matTooltip="A portfolio must contain at least 6 companies to generate a report."
      matTooltipPosition="above"
      >info_outline</mat-icon
    >
  </div>

  <div
    class="report-card"
    [ngClass]="cardClass"
    *ngIf="
      !vm.loading &&
      !vm.portfolioInsufficientCompanies &&
      vm.reports.length === 1
    "
  >
    <button
      id="reports-button"
      mat-flat-button
      [disabled]="vm.reports[0].disabled$ | async"
      (click)="onClick(vm.reports[0].id)"
    >
      <span class="report-button-label">
        <span class="report-button-label-prefix" *ngIf="buttonLabelPrefix">{{
          buttonLabelPrefix
        }}</span
        ><span class="report-button-label-base">{{ buttonLabel }}</span>
      </span>
      <mat-icon>picture_as_pdf</mat-icon>
    </button>
  </div>

  <div
    class="report-card"
    [ngClass]="cardClass"
    *ngIf="
      !vm.loading && !vm.portfolioInsufficientCompanies && vm.reports.length > 1
    "
  >
    <button
      id="reports-button"
      mat-flat-button
      [matMenuTriggerFor]="reportMenu"
    >
      <span class="report-button-label">
        <span class="report-button-label-prefix" *ngIf="buttonLabelPrefix">{{
          buttonLabelPrefix
        }}</span
        ><span class="report-button-label-base">{{ buttonLabel }}s</span>
      </span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #reportMenu="matMenu">
      <button
        mat-menu-item
        *ngFor="let r of vm.reports; trackBy: trackById"
        [id]="'reports-menu-' + r.id"
        [disabled]="r.disabled$ | async"
        (click)="onClick(r.id)"
      >
        <mat-icon>picture_as_pdf</mat-icon>
        <div
          class="report-menu-item"
          *ngIf="splitMenuTitle(r.menuTitle) as title"
        >
          <span>{{ title.base }}</span>
          <span class="report-menu-item__suffix" *ngIf="title.suffix">
            ({{ title.suffix }})
          </span>
        </div>
      </button>
    </mat-menu>
  </div>
</ng-container>
